import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import { Provider } from "react-redux";
import { store, persistor, sagaMiddleware } from "./Store";
import "./index.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import Saga from "./sagas/index";
import "./i18n";


Sentry.init({
  dsn: "https://daf904b905f64e749fc340a326204918@sentry.natrohost.com/3",
  environment : window.location.hostname.startsWith('localhost') ? 'DEV' : 'PROD'
});

sagaMiddleware.run(Saga);

const app = (
  <Provider store={store}>
    <Suspense fallback={<div>loading...</div>}>
      <BrowserRouter>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </BrowserRouter>
    </Suspense>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
